import { Component, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

import { Message } from './shared/entities/message';
import { Panic } from './shared/entities/panic';
import { User } from './shared/entities/user';

import { PanicService } from './shared/services/panic.service';

import { NotificationAlertComponent } from './core/components/notification/notification-alert.component';
import { PushNotificationComponent } from './core/components/notification/notification-native.component';

// Add the RxJS Observable operators.
import 'rxjs/Rx';
import { Observable, Observer, Subject } from 'rxjs/Rx';
import { AuthenticationService } from './shared/services/authentication.service';
import { NotificationService } from './shared/services/notification.service';
import { MatSnackBar, MatDialog } from '@angular/material';
import { DriverService } from './shared/services/driver.service';
import { Type } from '@angular/compiler/src/output/output_ast';
import { NotificationType } from './shared/entities/notification-type';
import { ChangePasswordDialogComponent } from './core/components/change-password/change-password.component';
import { Router } from '@angular/router';
import { OrderService } from './shared/services/order.service';
import { CompanyService } from './shared/services/company.service';
import { DeliveryService } from './shared/services/delivery.service';
import { SortEvent } from './shared/directives/draggable/sortable-list.directive';
import { Howl, Howler } from 'howler';
import { forEach } from '@angular/router/src/utils/collection';
import { NotificationAlert } from './shared/entities/notification-alert';
import { TrackerService } from './shared/services/tracker.service';
import { SERVER_URL } from './shared/services/server-url';
import { Location } from '@angular/common';

import { CookieService } from 'ngx-cookie-service';

declare var require:any;

@Component({
  selector: 'frotas-app',
  template: require('./app.component.html'),
  styles: [ require('./app.component.css')],
  //providers: [ PanicService ],
  
})
class AppComponent { 
    
    @ViewChild(NotificationAlertComponent) public notificationAlertComponent:NotificationAlertComponent;

    public isRequestNotifications:boolean = false;

    public userLogged:User;

    public menuOpen:boolean = false;
    private panicState = "void";
    
    public panics:Array<Panic>;

    private timerSubscription: any;   //just to hold the reference
    private timer:any;
    private ngUnsubscribe: Subject<void> = new Subject<void>(); 
    private sound = new Howl({
        src: [SERVER_URL + '/api/sounds/sirene.wav']
    });
    
    constructor (public authenticationService: AuthenticationService,
                  public notificationService: NotificationService,
                  public driverService:DriverService,
                  public orderService:OrderService,
                  public companyService:CompanyService,
                  public trackerService:TrackerService,
                  public cookieService:CookieService,
                  public location:Location,
                  public snackBar: MatSnackBar,
                  public dialog: MatDialog,                
                  public router:Router) {

        var token = this.cookieService.get('ahura-token');
        var username = this.cookieService.get('ahura-userinfo');

        if (token) {
            this.authenticationService.userLogged = new User(null, username, null, token);
        }

        this.authenticationService.isLoading = true;
        this.authenticationService.isOpenMenuModule = false;

        this.notificationService.notifications = null;
        this.notificationService.allNotifications = null;

        if (!this.authenticationService.userLogged) {
            this.router.navigate(["/login"]);
        } else {
            this.authenticationService.isLoading = true;

            var uri = this.location.path() ? this.location.path() : null;
            this.authenticationService.isLogged = true;                    

            if (uri && uri.indexOf('login') < 0) {
                this.router.navigate([uri]).then( () => {});

                //this.router.navigate(['entregas']).then( () => {});
            } else {                    
                this.router.navigate(['/rastreamento']).then( () => {});
            }
        }
        
        // Fires when the sound finishes playing.
        this.sound.on('end', function( ){
            var text:string = 'Atenção nova notificação de desvio de rota!';
            for (var tracker of trackerService.trackers) {
                for (var notificationNew of notificationService.newNotificationsOutOfRoute) {
                
                    if (tracker.id == notificationNew.tracker.id) {
                        text+='\nVeículo: ' + tracker.detail;
                        continue;
                    }                    
                }
            }
            snackBar.open(text, null, { duration: 8000, panelClass: 'snackbar-panel-error' });
            notificationService.newNotificationsOutOfRoute = [];
        });
    }
    
    private changeMenuModuleState(opened:boolean) {
        this.authenticationService.isOpenMenuModule = opened;
    }
    
    ngOnInit() {
        this.timer = Observable.timer(10000, 10000);
        this.timer.takeUntil(this.ngUnsubscribe).subscribe((t:any) => {
            if (this.authenticationService && this.authenticationService.userLogged && this.authenticationService.userLogged.token && !this.isRequestNotifications) {
                this.isRequestNotifications = true;

                this.notificationService.getNotificationsActive(this.authenticationService.userLogged.token)
                    .subscribe(
                        notifications => { 
                            //Todas ativas menos Desvio de rota
                            var results = [];
                            
                            for (var notification of notifications) {
                                if (notification.type.id != 8) {
                                    results.push(notification);
                                }
                            }

                            this.notificationService.notifications = results;

                            //Type 8 - Desvio de rota
                            this.notificationService.getNotificationsActiveByType(new NotificationType(8, null,null,null), this.authenticationService.userLogged.token)
                            .subscribe(
                                notifications => { 
                                    if (this.notificationService.notificationsOutOfRoute && this.notificationService.notificationsOutOfRoute.length < notifications.length) {
                                        for (var notificationNew of notifications) {
                                            var found = false;
                                            for (var notification of this.notificationService.notificationsOutOfRoute) {
                                                if (notificationNew.id == notification.id) {
                                                    found = true;
                                                    continue;
                                                }
                                            }
                                            if (!found) {
                                                this.notificationService.newNotificationsOutOfRoute.push(notificationNew);
                                            }
                                        }
                                        if (this.notificationService.isSoundActive) {
                                            this.sound.play();
                                        }
                                    }
                                    this.notificationService.notificationsOutOfRoute = notifications;
                                    //this.authenticationService.isLoading = false;
                                    this.isRequestNotifications = false;
                                },
                                error =>  {
                                    //this.authenticationService.isLoading = false;
                                    this.isRequestNotifications = false;
                                    this.openSnackBar('Problemas ao obter notificações de desvio de rota', true);
                                });

                        },
                        error =>  {
                            this.openSnackBar('Problemas ao obter notificações', true);
                        });
            }
        });      
    }

    onClickLogout() {
        this.cookieService.delete('ahura-userinfo');
        this.cookieService.delete('ahura-token');
        this.authenticationService.isLogged = false;
        this.authenticationService.userLogged = null;
        this.orderService.orders = null;
        this.companyService.companies = null;
        this.notificationService.notifications = null;
        this.notificationService.allNotifications = null;
        this.router.navigate(['/']);
        
    }
    
    ngOnDestroy() {
      //Called once, before the instance is destroyed.
      //Add 'implements OnDestroy' to the class.
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
  }

    openSnackBar(msg:string, isError:boolean) {
        if (isError) {
            this.snackBar.open(msg, null, { duration: 2500, panelClass: 'snackbar-panel-error' });
        } else {
            this.snackBar.open(msg, null, {
                duration: 3500,
            });
        }
    }

}
  
export { AppComponent };


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/app.component.ts